import React from 'react';

import { FieldProps } from '@api';
import { TextArea } from '@ui-library/input';
import { Form } from '@ui-library/form';

export const TextAreaField: React.FC<FieldProps<'textField'>> = ({ fieldConfig }) => (
  <Form.Item
    name={fieldConfig.key}
    label={fieldConfig.label}
    extra={fieldConfig.info}
    rules={[{ required: !fieldConfig.optional }, ...(fieldConfig.rules ?? [])]}
    initialValue={fieldConfig.default}
  >
    <TextArea
      placeholder={fieldConfig.placeholder}
      disabled={fieldConfig.disabled}
      variant={fieldConfig.variant}
    />
  </Form.Item>
);
